import { photoLayoutConfig } from '~/components/photoLayoutConfig';
import { PhotoLayout } from './PhotoLayout';

export function FrontPhoto() {
  return <PhotoLayout {...photoLayoutConfig['front']} />;
}
